"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9709],{

/***/ 62804:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ox": function() { return /* binding */ getCountries; },
  "IS": function() { return /* binding */ loginCallback; },
  "QO": function() { return /* binding */ userChangePassword; },
  "nu": function() { return /* binding */ userConfirmEmail; },
  "X1": function() { return /* binding */ userForgotPassword; },
  "cq": function() { return /* binding */ userGetProfile; },
  "Kv": function() { return /* binding */ userLogout; },
  "lf": function() { return /* binding */ userResendConfirmEmail; },
  "Fw": function() { return /* binding */ userRestorePassword; },
  "ii": function() { return /* binding */ userSignIn; },
  "EQ": function() { return /* binding */ userSignUp; },
  "lP": function() { return /* binding */ userUpdateProfile; }
});

// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
;// CONCATENATED MODULE: ./shared/models/endpoits/clients/clients.endpoints.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var ClientsStatic;

(function (ClientsStatic) {
  ClientsStatic["register"] = "/v2/clients/sign-up";
  ClientsStatic["login"] = "/v2/clients/login";
  ClientsStatic["logout"] = "/v2/clients/logout";
  ClientsStatic["forgotPassword"] = "/v2/clients/send-forgot-pasword";
  ClientsStatic["changePassword"] = "/v2/clients/change-password";
  ClientsStatic["confirmEmail"] = "/v2/clients/confirm-email";
  ClientsStatic["resendConfirmEmail"] = "/v2/clients/resend-confirm-email";
  ClientsStatic["profile"] = "/v2/clients";
  ClientsStatic["updateProfile"] = "/v2/clients/edit?_method=PUT";
  ClientsStatic["countries"] = "/v2/clients/countries";
})(ClientsStatic || (ClientsStatic = {}));

var ClientsDynamic = {
  /**
   * @member {string}
   * @method POST
   * @version 2.0
   * @description Send new password.
   */
  resetPassword: function resetPassword(userId) {
    return "/v2/clients/reset-password/" + userId;
  },

  /**
   * @member {string}
   * @method GET
   * @version 2.0
   * @description Send search params to callback for OAuth.
   */
  loginCallback: function loginCallback(provider) {
    return "/v2/clients/login/".concat(provider, "/callback");
  }
};
var ClientsEndpoints = _objectSpread(_objectSpread({}, ClientsDynamic), ClientsStatic);
;// CONCATENATED MODULE: ./api/clients/clients.request.ts


function userSignUp(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.register, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userSignIn(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.login, body).then(function (_ref) {
    var data = _ref.data;
    return data.data;
  });
}
function userLogout() {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.logout, null).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userForgotPassword(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.forgotPassword, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userRestorePassword(clientId, searchParams, body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.resetPassword(clientId) + searchParams, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userChangePassword(body) {
  return (0,base_services_request/* patchResquest */.Ft)(ClientsEndpoints.changePassword, body).then(function (_ref2) {
    var data = _ref2.data;
    return data;
  });
}
function userConfirmEmail(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.confirmEmail, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function userResendConfirmEmail(body) {
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.resendConfirmEmail, body).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data;
  });
}
function loginCallback(provider, searchParams) {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.loginCallback(provider) + searchParams).then(function (res) {
    return res === null || res === void 0 ? void 0 : res.data.data;
  });
}
function userUpdateProfile(body) {
  var useMultipartFormData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return (0,base_services_request/* postRequest */.j0)(ClientsEndpoints.updateProfile, body, useMultipartFormData).then(function (_ref3) {
    var data = _ref3.data;
    return data.data;
  });
}
function userGetProfile() {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.profile).then(function (_ref4) {
    var data = _ref4.data;
    return data.data;
  });
}
function getCountries() {
  return (0,base_services_request/* getRequest */.A_)(ClientsEndpoints.countries).then(function (_ref5) {
    var data = _ref5.data;
    return data.data;
  });
}

/***/ }),

/***/ 99109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useAppSelector; },
/* harmony export */   "T": function() { return /* binding */ useAppDispatch; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9473);

// Use throughout your app instead of plain `useDispatch` and `useSelector`
var useAppDispatch = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0;
var useAppSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9;

/***/ }),

/***/ 44231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useWidth; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90116);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61730);



function useWidth() {
  var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();

  var keys = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(theme.breakpoints.keys).reverse();

  return keys.reduce(function (output, key) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var matches = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(theme.breakpoints.up(key));
    return !output && matches ? key : output;
  }, null) || "xs";
}

/***/ }),

/***/ 83247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ReturnButton; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36864);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4730);
/* harmony import */ var _mui_icons_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94669);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93946);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70917);


var _excluded = ["aria-label"];



function ReturnButton(props) {
  var ariaLabel = props["aria-label"],
      rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, rest, {
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : "return"
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_mui_icons_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null));
}

/***/ }),

/***/ 44135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4730);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50029);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64666);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48228);
/* harmony import */ var custom_hooks_useSnackBar_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71652);
/* harmony import */ var _contact_agent_dialog_ContactForm__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50109);
/* harmony import */ var api_messages_request__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27929);
/* harmony import */ var _components_message_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36481);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var custom_hooks_data_layer_event_hook__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(65198);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70917);




var _excluded = ["captcha"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var postData = /*#__PURE__*/function () {
  var _ref = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().mark(function _callee(data) {
    var response;
    return _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_2___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0,api_messages_request__WEBPACK_IMPORTED_MODULE_6__/* .postMessageContact */ .eT)(data);

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function postData(_x) {
    return _ref.apply(this, arguments);
  };
}();

function ContactDialog(props) {
  var open = props.open,
      onClose = props.onClose;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      openModal = _useState[0],
      setOpenModal = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false),
      isSubscribed = _useState2[0],
      setIsSubscribed = _useState2[1];

  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_9__.useTranslations)("alerts.contact");
  var translationTitle = (0,next_intl__WEBPACK_IMPORTED_MODULE_9__.useTranslations)("contactForm");

  var _useDataLayerEvent = (0,custom_hooks_data_layer_event_hook__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(),
      event = _useDataLayerEvent.event;

  var _useSnackBar = (0,custom_hooks_useSnackBar_hook__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      showMessage = _useSnackBar.showMessage;

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_11__/* .useMutation */ .D)(postData, {
    onSuccess: function onSuccess() {
      handleOpenModal();
      onClose();
    },
    onError: function onError() {
      return showMessage(translation("error"), {
        variant: "error"
      });
    }
  }),
      mutateAsync = _useMutation.mutateAsync,
      isLoading = _useMutation.isLoading;

  var handleOpenModal = function handleOpenModal() {
    setOpenModal(true);
  };

  var handleCloseModal = function handleCloseModal() {
    setOpenModal(false);
  };

  var onSubmit = function onSubmit(values) {
    var captcha = values.captcha,
        rest = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(values, _excluded);

    var data = _objectSpread({}, rest);

    data["g-recaptcha-response"] = captcha;
    setIsSubscribed(data["subscribe"]);
    mutateAsync(data).then(function () {
      event({
        event_name: "contact_form_menu",
        body: {//
        }
      });
    });
  };

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledDialog, {
    open: open
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_contact_agent_dialog_ContactForm__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    onSubmit: onSubmit,
    onClose: onClose,
    title: translationTitle("title"),
    classNameModalButton: props.classNameModalButton,
    isLoading: isLoading,
    className: "contact"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(StyledModalMessage, {
    title: translation("titleSuccess"),
    body: isSubscribed ? translation("bodySuccessSubscribe") : translation("bodySuccess"),
    open: openModal,
    handleClose: handleCloseModal
  }));
}

/* harmony default export */ __webpack_exports__["Z"] = (ContactDialog);

var StyledDialog = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z,  true ? {
  target: "e1gqu3en1"
} : 0)( true ? {
  name: "2dq3js",
  styles: "& .MuiDialog-paper{background-color:var(#efeff1);border-radius:20px;}"
} : 0);

var StyledModalMessage = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_components_message_modal__WEBPACK_IMPORTED_MODULE_7__/* .ModalMessage */ .P,  true ? {
  target: "e1gqu3en0"
} : 0)( true ? {
  name: "983j4x",
  styles: "& .MuiBox-root{width:90%;border-radius:20px;max-width:400px;}"
} : 0);

/***/ }),

/***/ 44959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ForgotPasswordForm; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86886);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _text_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22900);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66621);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74231);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48228);
/* harmony import */ var api_clients_clients_request__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62804);
/* harmony import */ var _message_modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36481);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }












var initialValues1 = {
  email: "",
  "g-recaptcha-response": ""
};
function ForgotPasswordForm(props) {
  var onClose = props.onClose;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      showMessage = _useState[0],
      setShowMessage = _useState[1];

  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__.useTranslations)("restorePasswordForm");
  var tErrors = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__.useTranslations)("error");
  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_5__/* .object */ .Ry({
    email: yup__WEBPACK_IMPORTED_MODULE_5__/* .string */ .Z_().email(tErrors("email")).required(tErrors("required")) // "g-recaptcha-response": yup.string().required(tErrors("captcha")),

  });

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(api_clients_clients_request__WEBPACK_IMPORTED_MODULE_6__/* .userForgotPassword */ .X1, {
    onSuccess: function onSuccess() {
      return setShowMessage(true);
    },
    onError: console.log //?

  }),
      mutateAsync = _useMutation.mutateAsync,
      isLoading = _useMutation.isLoading;

  function onSuccessClose() {
    setShowMessage(false);
    if (onClose) onClose();
  }

  var onSubmit = function onSubmit(values) {
    return mutateAsync(values);
  };

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
    container: true,
    mb: 5
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
    item: true,
    xs: 12,
    sm: 9,
    textAlign: "center",
    margin: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("h3", {
    css: styles.title
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(BoldTitle, null, t("header.title-left")), "\xA0", (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ThinTitle, null, t("header.title-right"))))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
    initialValues: initialValues1,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true
  }, function (formikProps) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
      container: true,
      spacing: 2
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 8,
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_text_field__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      name: "email",
      label: t("field.email")
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      textAlign: "center",
      mb: 2
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      type: "submit",
      fs: "12px",
      bg: "--color-brand-red-main",
      thin_button: true,
      disabled: isLoading,
      loadingMessage: isLoading ? t("sending") : null
    }, t("submitBtn")))));
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_message_modal__WEBPACK_IMPORTED_MODULE_7__/* .ModalMessage */ .P, {
    title: t("successMsg.title"),
    body: t("successMsg.content"),
    open: showMessage,
    handleClose: onSuccessClose
  }));
}

var BoldTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1yhrbee1"
} : 0)( true ? {
  name: "15p8j2o",
  styles: "font-weight:700;text-transform:uppercase"
} : 0);

var ThinTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1yhrbee0"
} : 0)( true ? {
  name: "148c1u2",
  styles: "font-weight:300;text-transform:uppercase"
} : 0);

var styles = {
  title: {
    marginBottom: 21
  }
};

/***/ }),

/***/ 79709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/footer/components/power-by.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function PowerBy() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("footer.powerBy");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(PowerByContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
    src: "/images/v2/logos/4.png",
    alt: "Logo Re/max",
    sx: {
      width: 200,
      height: 75,
      objectFit: "cover"
    },
    variant: "square"
  }), (0,emotion_react_browser_esm/* jsx */.tZ)("p", {
    style: {
      paddingTop: "10px"
    }
  }, translation("title", {
    year: new Date().getFullYear()
  })), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, translation.rich("subtitle", {
    link: function link(chunks) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
        href: "https://version.do/",
        target: "_blank",
        rel: "noopener noreferrer"
      }, chunks);
    }
  })));
}

/* harmony default export */ var power_by = (PowerBy);

var PowerByContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1cko0oi1"
} : 0)( true ? {
  name: "g2i98o",
  styles: "width:100%;background-color:white;display:flex;justify-content:center;flex-direction:column;padding:15px;align-items:center;text-align:center;p{font-style:normal;font-weight:700;font-size:12px;line-height:13px;display:block;color:var(--color-brand-grey-main);}a{color:var(--color-brand-version);}"
} : 0);

var LogoRemax = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "e1cko0oi0"
} : 0)( true ? {
  name: "1yaiq4p",
  styles: "padding-bottom:10px"
} : 0);
;// CONCATENATED MODULE: ./shared/components/footer/index.tsx




var Footer = function Footer() {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(power_by, null);
};

/* harmony default export */ var footer = (Footer);
// EXTERNAL MODULE: ./node_modules/@mui/material/AppBar/AppBar.js + 1 modules
var AppBar = __webpack_require__(42293);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js + 1 modules
var Toolbar = __webpack_require__(10155);
// EXTERNAL MODULE: ./custom-hooks/use-width.hook.ts
var use_width_hook = __webpack_require__(44231);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Menu.js
var icons_material_Menu = __webpack_require__(326);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./shared/models/const/pages-path.ts
var pages_path = __webpack_require__(1283);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Business.js
var Business = __webpack_require__(54788);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Book.js
var Book = __webpack_require__(99613);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AlternateEmail.js
var AlternateEmail = __webpack_require__(7507);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PersonAddAlt1.js
var PersonAddAlt1 = __webpack_require__(39069);
;// CONCATENATED MODULE: ./shared/models/const/navsLink.const.ts






function useRemaxIntlNavLinks() {
  var translation = (0,next_intl_cjs_production_min.useTranslations)("header");
  var CNavLinksRemaxRd = [{
    slug: translation("agent"),
    link: pages_path/* CPagesPath.es.join */.K.es.join,
    icon: PersonAddAlt1/* default */.Z
  }, {
    slug: translation("franchise"),
    link: pages_path/* CPagesPath.es.franchises */.K.es.franchises,
    icon: Business/* default */.Z
  }, {
    slug: translation("blog"),
    link: pages_path/* CPagesPath.blog */.K.blog,
    icon: Book/* default */.Z,
    target: "_blank"
  }, {
    slug: translation("contact"),
    link: "/contactanos",
    icon: AlternateEmail/* default */.Z
  }];
  return CNavLinksRemaxRd;
}
var CNavLinksRemaxRd = [{
  slug: "Sé un agente",
  link: pages_path/* CPagesPath.es.join */.K.es.join,
  icon: PersonAddAlt1/* default */.Z
}, {
  slug: "Adquiere una franquicia",
  link: pages_path/* CPagesPath.es.franchises */.K.es.franchises,
  icon: Business/* default */.Z
}, {
  slug: "Blog",
  link: pages_path/* CPagesPath.blog */.K.blog,
  icon: Book/* default */.Z,
  target: "_blank"
}, {
  slug: "Contáctanos",
  link: "/contactanos",
  icon: AlternateEmail/* default */.Z
}];
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
;// CONCATENATED MODULE: ./shared/components/nav-bar/components/Logo.tsx







var REMAX_RD_HOME_URL = "https://remaxrd.com";
var CollectionLogoContent = (0,styled/* default */.ZP)(Box/* default */.Z)({
  position: "relative",
  width: "150px",
  alignSelf: "flex-start"
});
var ContentLogo = (0,styled/* default */.ZP)(Box/* default */.Z)({
  position: "absolute",
  padding: "1rem",
  top: "-38px",
  left: "-5px",
  width: "100%",
  height: "100px",
  background: "var(--color-brand-blue-collection-main)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "0 0 20px 20px"
});
var LogoImage = (0,styled/* default */.ZP)((image_default()))({
  cursor: "pointer"
});
var Logo = /*#__PURE__*/react.forwardRef(function FLogo(props, ref) {
  var location = (0,next_router.useRouter)();
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, null, location.pathname.includes(pages_path/* CPagesPath.es.collection */.K.es.collection) ? (0,emotion_react_browser_esm/* jsx */.tZ)(CollectionLogo, {
    ref: ref
  }) : (0,emotion_react_browser_esm/* jsx */.tZ)(RemaxRdLogo, {
    ref: ref
  }));
});
/* harmony default export */ var components_Logo = (Logo);
var CollectionLogo = /*#__PURE__*/react.forwardRef(function FCollection(props, ref) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(CollectionLogoContent, {
    ref: ref
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentLogo, null, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: REMAX_RD_HOME_URL,
    className: "logo",
    "aria-label": "RE/MAX RD"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
    src: "/images/v2/logos/collection-03.png",
    alt: "Logo Re/max",
    sx: {
      width: 120,
      height: "auto",
      objectFit: "cover"
    },
    variant: "square"
  }))));
});
var RemaxRdLogo = /*#__PURE__*/react.forwardRef(function FRemax(props, ref) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
    href: REMAX_RD_HOME_URL,
    className: "logo__link",
    ref: ref,
    "aria-label": "RE/MAX RD"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Avatar/* default */.Z, {
    src: "/images/v2/logos/8.png",
    alt: "Logo Re/max",
    sx: {
      width: 200,
      height: "auto",
      objectFit: "contain"
    },
    variant: "square"
  }));
});
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./shared/components/contact-dialog/index.tsx
var contact_dialog = __webpack_require__(44135);
;// CONCATENATED MODULE: ./shared/models/const/idiomsconst.ts
/**
 *
 * @comments
 *  use this format for picture
 *  .webp
 *  .idioms_flag
 *  30px x 20px ~~
 */
var CIdioms = [{
  icon: "/icons/dominican-republic-flag.jpg",
  alt: "Bandera República Dominicana",
  link: "/es",
  name: "Español",
  acronym: "ES"
}, {
  icon: "/icons/united-states-flag.jpg",
  alt: "Bandera Estados Unidos",
  link: "/en",
  name: "English",
  acronym: "EN"
} // {
//   icon: "/icons/fr_flag.webp",
//   alt: "Bandera francia",
//   link: "/fr",
// },
];
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
;// CONCATENATED MODULE: ./shared/components/mobile-menu-item/index.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function mobile_menu_item_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






function MobileMenuItem(_ref) {
  var _item$link, _item$link2, _children, _children2;

  var item = _ref.item,
      handleOpen = _ref.handleOpen;
  var itemButtonStyles = getMobileItemButtonStyles(item.link);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Divider/* default */.Z, null), (0,emotion_react_browser_esm/* jsx */.tZ)(ListItem/* default */.ZP, null, handleOpen ? (0,emotion_react_browser_esm/* jsx */.tZ)(ListItemButton/* default */.Z, {
    sx: itemButtonStyles,
    onClick: handleOpen
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ItemImageIcon, {
    item: item
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(ListItemTextCustom, null, item.slug)) : item.target ? (0,emotion_react_browser_esm/* jsx */.tZ)(ListItemButton/* default */.Z, {
    component: "a",
    href: (_item$link = item.link) !== null && _item$link !== void 0 ? _item$link : "",
    target: item.target,
    rel: "noopener noreferrer",
    sx: itemButtonStyles
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ItemImageIcon, {
    item: item
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(ListItemTextCustom, null, item.slug)) : (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
    href: (_item$link2 = item.link) !== null && _item$link2 !== void 0 ? _item$link2 : ""
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ListItemButton/* default */.Z, {
    LinkComponent: "a",
    sx: itemButtonStyles
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(ItemImageIcon, {
    item: item
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(ListItemTextCustom, null, item.slug)))), (0,emotion_react_browser_esm/* jsx */.tZ)(Divider/* default */.Z, null), ((_children = item.children) === null || _children === void 0 ? void 0 : _children.length) && ((_children2 = item.children) === null || _children2 === void 0 ? void 0 : _children2.map(function (item, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(MobileMenuItem, {
      key: i,
      item: item
    });
  })));
}

var getMobileItemButtonStyles = function getMobileItemButtonStyles(link) {
  var baseStyles = {
    textAlign: "left",
    whiteSpace: "nowrap"
  };

  if (link !== pages_path/* CPagesPath.es.join */.K.es.join && link !== pages_path/* CPagesPath.es.franchises */.K.es.franchises) {
    return baseStyles;
  }

  return _objectSpread(_objectSpread({}, baseStyles), {}, {
    mx: -0.5,
    my: 0.5,
    minHeight: 46,
    px: 1,
    borderRadius: "999px",
    color: "var(--color-text-white)",
    backgroundColor: link === pages_path/* CPagesPath.es.join */.K.es.join ? "var(--color-brand-blue-main)" : "var(--color-brand-red-main)",
    boxShadow: "0 12px 26px rgba(0, 0, 0, 0.16)",
    "&:hover": {
      backgroundColor: link === pages_path/* CPagesPath.es.join */.K.es.join ? "var(--color-brand-blue-secondary)" : "var(--color-brand-red-main)"
    },
    "& .MuiListItemIcon-root": {
      color: "var(--color-text-white)",
      minWidth: 30
    },
    "& .MuiSvgIcon-root": {
      color: "var(--color-text-white)"
    },
    "& .MuiTypography-root": {
      color: "var(--color-text-white)",
      fontSize: "0.86rem",
      fontWeight: 700,
      lineHeight: 1.15,
      overflow: "visible",
      textOverflow: "clip",
      width: "auto"
    }
  });
};

var ItemImageIcon = function ItemImageIcon(_ref2) {
  var item = _ref2.item;
  return (0,emotion_react_browser_esm/* jsx */.tZ)(ListItemIcon/* default */.Z, {
    sx: {
      minWidth: 36
    }
  }, item.iconComponent ? item.iconComponent : typeof item.icon === "string" ? (0,emotion_react_browser_esm/* jsx */.tZ)(Image, {
    src: item.icon,
    alt: "profile icon"
  }) : item.icon && (0,emotion_react_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
    component: item.icon,
    inheritViewBox: true
  }));
};

var Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1780kkj1"
} : 0)( true ? {
  name: "8r5f6l",
  styles: "width:30px;height:20px;filter:grayscale(1)"
} : 0);

var ListItemTextCustom = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ListItemText/* default */.Z,  true ? {
  target: "e1780kkj0"
} : 0)( true ? {
  name: "edyu9f",
  styles: ".MuiTypography-root{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;width:155px;}"
} : 0);
;// CONCATENATED MODULE: ./shared/components/nav-bar/components/MobileMenu.tsx


function MobileMenu_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var MobileMenu = /*#__PURE__*/react.forwardRef(function Menu(props, ref) {
  var _useState = (0,react.useState)(false),
      open = _useState[0],
      isOpen = _useState[1];

  var _useState2 = (0,react.useState)(false),
      openModal = _useState2[0],
      setOpenModal = _useState2[1];

  var handleToggleMenu = function handleToggleMenu() {
    isOpen(!open);
  };

  var handleOpenModal = function handleOpenModal() {
    setOpenModal(true);
  };

  var handleCloseModal = function handleCloseModal() {
    setOpenModal(false);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(components_Logo, null), (0,emotion_react_browser_esm/* jsx */.tZ)(Spacing, null), (0,emotion_react_browser_esm/* jsx */.tZ)(ToggleIconMenu, {
    onClick: handleToggleMenu
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(icons_material_Menu/* default */.Z, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentSliderMenu, {
    open: open,
    handleToggleMenu: handleToggleMenu,
    handleOpenModal: handleOpenModal
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(contact_dialog/* default */.Z, {
    open: openModal,
    onClose: handleCloseModal
  }));
});
/* harmony default export */ var components_MobileMenu = (MobileMenu);

var ContentSliderMenu = function ContentSliderMenu(props) {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    component: "nav"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(SliderBox, {
    anchor: "right",
    open: props.open,
    onClose: props.handleToggleMenu
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(DrawerItems, props)));
};

var DrawerItems = function DrawerItems(props) {
  var location = (0,next_router.useRouter)();
  var translation = (0,next_intl_cjs_production_min.useTranslations)("header");
  var paths = useRemaxIntlNavLinks();
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      textAlign: "center"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(List/* default */.Z, {
    sx: {},
    onClick: props.handleToggleMenu
  }, paths.map(function (item, i) {
    if (item.slug === translation("contact")) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)(MobileMenuItem, {
        item: item,
        key: i,
        handleOpen: props.handleOpenModal
      });
    }

    return (0,emotion_react_browser_esm/* jsx */.tZ)(MobileMenuItem, {
      item: item,
      key: i
    });
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(Language, null, CIdioms.map(function (idioms, i) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      href: "".concat(idioms.link + location.asPath),
      key: i,
      locale: false
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
      onClick: props.handleToggleMenu
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(MobileMenu_Image, {
      src: idioms.icon,
      alt: idioms.alt
    })));
  }))));
};

var ToggleIconMenu = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(IconButton/* default */.Z,  true ? {
  target: "eo03e4k3"
} : 0)( true ? {
  name: "8dndb8",
  styles: "flex-self:flex-end"
} : 0);

var SliderBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Drawer/* default */.ZP,  true ? {
  target: "eo03e4k2"
} : 0)( true ? {
  name: "6m08z7",
  styles: "width:475px;& .MuiDrawer-paper{box-sizing:'border-box';width:60vw;border-radius:10px 0px 10px 0px;}"
} : 0);

var MobileMenu_Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "eo03e4k1"
} : 0)( true ? {
  name: "h21yto",
  styles: "width:30px;height:20px"
} : 0);

var Language = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eo03e4k0"
} : 0)( true ? {
  name: "16sm9m8",
  styles: "display:flex;width:100%;justify-content:space-between;margin-top:30px;max-width:80px;margin-left:auto;margin-right:auto"
} : 0);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
// EXTERNAL MODULE: ./node_modules/@mui/material/Menu/Menu.js + 5 modules
var Menu = __webpack_require__(35294);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./shared/components/Button/index.tsx
var Button = __webpack_require__(66621);
;// CONCATENATED MODULE: ./shared/components/nav-bar/components/flats.tsx



function flats_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function FlatsSelector() {
  var _React$useState = react.useState(null),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _React$useState3 = react.useState("ES"),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      idiomState = _React$useState4[0],
      setIdiomState = _React$useState4[1];

  var open = Boolean(anchorEl);
  var router = (0,next_router.useRouter)();

  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };

  var handleClose = function handleClose() {
    setAnchorEl(null);
  };

  var handleIdiomChange = function handleIdiomChange(idiom) {
    setTimeout(function () {
      setIdiomState(idiom.acronym);
      localStorage.setItem("idiom", idiom.acronym);
      router.push(router.asPath, router.asPath, {
        locale: idiom.acronym.toLowerCase()
      });
    }, 1000);
  };

  var LoaderIdiom = function LoaderIdiom() {
    // get idiom from localstorage
    var idiom = localStorage.getItem("idiom"); // if idiom is not null set idiom state if not set timeout to click on idiom selector

    if (idiom) {
      setIdiomState(idiom.toLowerCase());
    } else {
      localStorage.setItem('idiom', idiomState.toUpperCase());
    }
  };

  react.useEffect(function () {
    LoaderIdiom();
  }, []);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(FlagsContainer, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    id: "idiom-selector",
    variant: "text",
    className: "button_selector",
    onClick: handleClick
  }, idiomState), (0,emotion_react_browser_esm/* jsx */.tZ)(Menu/* default */.Z, {
    className: "menu",
    anchorEl: anchorEl,
    id: "idiom-menu",
    open: open,
    onClose: handleClose,
    onClick: handleClose,
    PaperProps: paperProps,
    transformOrigin: {
      horizontal: "right",
      vertical: "top"
    },
    anchorOrigin: {
      horizontal: "right",
      vertical: "bottom"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(TitleSelector, null, "Seleccione un idioma"), (0,emotion_react_browser_esm/* jsx */.tZ)(Box/* default */.Z, {
    sx: {
      mb: 2
    }
  }), CIdioms.map(function (idiom, i, row) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
      key: i
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(CustomMenuItem, {
      onClick: function onClick() {
        return handleIdiomChange(idiom);
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)((image_default()), {
      src: idiom.icon,
      alt: idiom.alt,
      width: 30,
      height: 20
    }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", null, idiom.name, " (", idiom.acronym, ")")), i != row.length - 1 && (0,emotion_react_browser_esm/* jsx */.tZ)(Divider/* default */.Z, null));
  })));
}

var FlagsContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1w3zzg12"
} : 0)( true ? {
  name: "dhnlod",
  styles: "border-left:1px solid #000;padding:0 0px;font-weight:700;color:var(--color-brand-blue-main);display:flex;align-items:center;.button_selector.MuiButton-root{width:50px;min-width:50px;padding:0px;font-size:0.8988rem;font-weight:700;color:var(--color-brand-blue-main);font-family:var(--FF-SF);}.title_selector{font-size:1rem;font-weight:700;color:var(--color-brand-blue-main);font-family:var(--FF-SF);padding:10px 0;}@media (max-width: 768px){border-left:none;}"
} : 0);

var TitleSelector = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1w3zzg11"
} : 0)( true ? {
  name: "5cv694",
  styles: "font-size:0.938rem;font-weight:700;color:var(--color-brand-blue-main);font-family:var(--FF-SF);padding:15px 0"
} : 0);

var CustomMenuItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(MenuItem/* default */.Z,  true ? {
  target: "e1w3zzg10"
} : 0)( true ? {
  name: "1hy1cg6",
  styles: "font-size:14px;font-weight:700;color:var(--color-brand-blue-main);font-family:var(--FF-SF);padding:10px 0;text-transform:uppercase;display:flex;align-items:center;column-gap:10px;img{width:50px;height:30px;}span{font-size:0.813rem;}"
} : 0);

var paperProps = {
  elevation: 1,
  sx: {
    p: 2,
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    background: "white",
    mt: 1.5,
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0
    }
  }
};
;// CONCATENATED MODULE: ./shared/components/nav-bar/components/DesktopMenu.tsx


function DesktopMenu_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var DesktopMenu = function DesktopMenu() {
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(components_Logo, null), (0,emotion_react_browser_esm/* jsx */.tZ)(Spacing, null), (0,emotion_react_browser_esm/* jsx */.tZ)(NavLinksRender, null), (0,emotion_react_browser_esm/* jsx */.tZ)(FlatsSelector, null));
};

/* harmony default export */ var components_DesktopMenu = (DesktopMenu);

var NavLinksRender = function NavLinksRender() {
  var _useState = (0,react.useState)(false),
      open = _useState[0],
      setOpen = _useState[1];

  var translation = (0,next_intl_cjs_production_min.useTranslations)("header");
  var paths = useRemaxIntlNavLinks();

  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContainerLinks, {
    className: "navbar_desktop__list_items"
  }, paths.map(function (item, i) {
    var _item$link;

    if (item.slug === translation("contact")) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)("li", {
        key: i
      }, (0,emotion_react_browser_esm/* jsx */.tZ)(ModalBtn, {
        onClick: handleOpen
      }, item.slug));
    }

    return (0,emotion_react_browser_esm/* jsx */.tZ)("li", {
      key: i
    }, !(item !== null && item !== void 0 && item.target) && (0,emotion_react_browser_esm/* jsx */.tZ)((link_default()), {
      href: (_item$link = item.link) !== null && _item$link !== void 0 ? _item$link : "",
      passHref: true
    }, (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
      className: getNavLinkClassName(item.link, item === null || item === void 0 ? void 0 : item.bold)
    }, item.slug)), (item === null || item === void 0 ? void 0 : item.target) && (0,emotion_react_browser_esm/* jsx */.tZ)("a", {
      href: item.link,
      target: "_blank",
      rel: "noopener noreferrer",
      className: getNavLinkClassName(item.link, item === null || item === void 0 ? void 0 : item.bold)
    }, item.slug));
  })), (0,emotion_react_browser_esm/* jsx */.tZ)(contact_dialog/* default */.Z, {
    open: open,
    onClose: handleClose,
    classNameModalButton: "enviar-formulario-contacto-menu"
  }));
};

var getNavLinkClassName = function getNavLinkClassName(link, bold) {
  var classes = [];
  if (bold) classes.push("bold");
  if (link === pages_path/* CPagesPath.es.join */.K.es.join) classes.push("nav-pill", "nav-pill-agent");

  if (link === pages_path/* CPagesPath.es.franchises */.K.es.franchises) {
    classes.push("nav-pill", "nav-pill-franchise");
  }

  return classes.join(" ");
};

var ContainerLinks = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e3juuf22"
} : 0)( true ? {
  name: "p86a2",
  styles: "list-style:none;display:flex;align-items:center;li{display:inline-block;margin-right:18px;font-family:var(--font-family);font-size:0.938rem;font-weight:400;line-height:14px;letter-spacing:0px;vertical-align:middle;a{color:black;transition:transform 180ms ease,box-shadow 180ms ease,opacity 180ms ease;}a.bold{font-weight:bold;}a.nav-pill{display:inline-flex;align-items:center;justify-content:center;min-height:38px;padding:0.65rem 1.15rem;border-radius:999px;color:var(--color-text-white);font-weight:700;line-height:1;white-space:nowrap;box-shadow:0 12px 28px rgba(0, 0, 0, 0.16);}a.nav-pill:hover{transform:translateY(-1px);box-shadow:0 16px 34px rgba(0, 0, 0, 0.2);opacity:0.96;}a.nav-pill-agent{background-color:var(--color-brand-blue-main);}a.nav-pill-franchise{background-color:var(--color-brand-red-main);}@media screen and (max-width: 1000px){font-size:0.9rem;margin-right:8px;a.nav-pill{min-height:36px;padding:0.6rem 0.9rem;}}}"
} : 0);

var ModalBtn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e3juuf21"
} : 0)( true ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : 0);

var DesktopMenu_FlagsContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3juuf20"
} : 0)( true ? {
  name: "1y2z4rg",
  styles: "border-left:1px solid #000;border-right:1px solid #000;padding:0 15px;margin-right:5px;font-weight:700;color:var(--color-brand-blue-main);display:flex;align-items:center;a{display:inline-block;margin-left:15px;}img{width:30px;vertical-align:middle;}.select-idiom{border:none;}@media screen and (max-width: 1000px){padding:0 10px;font-size:14px;}"
} : 0);
// EXTERNAL MODULE: ./custom-hooks/redux.hooks.ts
var redux_hooks = __webpack_require__(99109);
// EXTERNAL MODULE: ./store/feature/auth/auth-dialog.slice.ts
var auth_dialog_slice = __webpack_require__(54540);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogTitle/DialogTitle.js
var DialogTitle = __webpack_require__(37645);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/DialogContent/DialogContent.js + 1 modules
var DialogContent = __webpack_require__(6514);
// EXTERNAL MODULE: ./node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(64666);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(90116);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs + 1 modules
var useMutation = __webpack_require__(48228);
// EXTERNAL MODULE: ./api/clients/clients.request.ts + 1 modules
var clients_request = __webpack_require__(62804);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./shared/components/checkBox/index.tsx
var checkBox = __webpack_require__(90443);
// EXTERNAL MODULE: ./shared/components/label-field/index.tsx
var label_field = __webpack_require__(78836);
// EXTERNAL MODULE: ./store/feature/auth/auth.slice.ts
var auth_slice = __webpack_require__(42550);
// EXTERNAL MODULE: ./custom-hooks/useGetPersintParamas.hook.ts
var useGetPersintParamas_hook = __webpack_require__(53541);
// EXTERNAL MODULE: ./custom-hooks/data-layer-event.hook.ts
var data_layer_event_hook = __webpack_require__(65198);
;// CONCATENATED MODULE: ./shared/components/forms/complete-signup-form/index.tsx



function complete_signup_form_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















function CompleteSignUpForm() {
  var _useDataLayerEvent = (0,data_layer_event_hook/* default */.Z)(),
      event = _useDataLayerEvent.event;

  var refererValue = (0,useGetPersintParamas_hook/* default */.Z)({
    onlyCode: true
  });
  var user = (0,redux_hooks/* useAppSelector */.C)(function (_ref) {
    var Auth = _ref.Auth;
    return Auth.user;
  });

  var _useState = (0,react.useState)([]),
      types = _useState[0],
      setTypes = _useState[1];

  var dispatch = (0,redux_hooks/* useAppDispatch */.T)();
  var t = (0,next_intl_cjs_production_min.useTranslations)("CompleteSignUpDialog.form");
  var tError = (0,next_intl_cjs_production_min.useTranslations)("error");
  var tShared = (0,next_intl_cjs_production_min.useTranslations)("shared");
  var userTypes = ["Comprador", "Propietario", "Agente"];
  var router = (0,next_router.useRouter)();
  var initialValues = {
    full_name: user === null || user === void 0 ? void 0 : user.full_name,
    type: "",
    is_subscribed: true,
    email: user === null || user === void 0 ? void 0 : user.email
  };
  var validationSchema = (0,es/* object */.Ry)({
    full_name: (0,es/* string */.Z_)(),
    type: (0,es/* array */.IX)().min(1, tError("field-length-min-one")).required(tError("required")),
    is_subscribed: (0,es/* boolean */.O7)(),
    email: (0,es/* string */.Z_)()
  });

  var _useMutation = (0,useMutation/* useMutation */.D)(clients_request/* userUpdateProfile */.lP, {
    onSuccess: function onSuccess(user) {
      dispatch((0,auth_slice/* setUser */.av)(user));
      dispatch((0,auth_dialog_slice/* closeAuthDialog */.iw)());
      router.push(pages_path/* CPagesPath.es.profile */.K.es.profile);
    }
  }),
      mutate = _useMutation.mutate,
      isLoading = _useMutation.isLoading,
      mutateAsync = _useMutation.mutateAsync;

  var cancel = function cancel() {
    dispatch((0,auth_slice/* logout */.kS)());
    dispatch((0,auth_dialog_slice/* closeAuthDialog */.iw)());
  };

  var onSubmit = function onSubmit(values) {
    mutateAsync(values).then(function () {
      var _ref2, _refererValue$arefere;

      event({
        event_name: "sign_up",
        body: {
          tipo_usuario: values.type,
          codigo_referido: (_ref2 = (_refererValue$arefere = refererValue.areferer) !== null && _refererValue$arefere !== void 0 ? _refererValue$arefere : refererValue.referer) !== null && _ref2 !== void 0 ? _ref2 : null,
          refererForAgent: refererValue.referer ? true : false,
          refererForAgency: refererValue.areferer ? true : false
        }
      });
    });
  };

  var SelectType = function SelectType(type, fh) {
    if (types.includes(type)) {
      fh.setFieldValue("type", types.filter(function (item) {
        return item !== type;
      }));
      setTypes(types.filter(function (item) {
        return item !== type;
      }));
    } else {
      fh.setFieldValue("type", [].concat((0,toConsumableArray/* default */.Z)(types), [type]));
      setTypes([].concat((0,toConsumableArray/* default */.Z)(types), [type]));
    }
  };

  var cards = [{
    msg: t("field.cards.buyer.description"),
    type: t("field.cards.buyer.title"),
    value: userTypes[0],
    isActive: types.includes(userTypes[0])
  }, {
    msg: t("field.cards.owner.description"),
    type: t("field.cards.owner.title"),
    value: userTypes[1],
    isActive: types.includes(userTypes[1])
  }, {
    msg: t("field.cards.agent.description"),
    type: t("field.cards.agent.title"),
    value: userTypes[2],
    isActive: types.includes(userTypes[2])
  }];
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Formik */.J9, {
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true
  }, function (formikProps) {
    return (0,emotion_react_browser_esm/* jsx */.tZ)(formik_esm/* Form */.l0, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      container: true,
      spacing: 3
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      sm: 12,
      margin: "auto"
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(GridCardContent, null, cards.map(function (card, i) {
      return (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
        key: i,
        onClick: function onClick() {
          return SelectType(card.value, formikProps);
        },
        className: card.isActive ? "active" : ""
      }, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", null, card.type), (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, card.msg));
    }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Error, null, formikProps.errors.type), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      sm: 10,
      margin: "auto",
      style: {
        display: "flex",
        alignItems: "center",
        marginLeft: "auto",
        justifyContent: "center"
      }
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(checkBox/* default */.Z, {
      onChange: function onChange() {
        formikProps.setFieldValue("is_subscribed", !formikProps.values.is_subscribed);
      },
      checked: !!formikProps.values.is_subscribed,
      name: "is_subscribed",
      style: {
        display: "inline-block",
        justifyContent: "flex-start",
        padding: "5px 0px 9px 9px"
      }
    }), (0,emotion_react_browser_esm/* jsx */.tZ)(ContentLabel, null, (0,emotion_react_browser_esm/* jsx */.tZ)(label_field/* default */.Z, {
      label: t("field.is_subscribed"),
      positionLabel: "left"
    }))), (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
      item: true,
      xs: 12,
      textAlign: "center",
      mb: 2
    }, (0,emotion_react_browser_esm/* jsx */.tZ)(FormButtons, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      fs: "12px",
      bg: "transparent",
      variant: "text",
      thin_button: true,
      onClick: cancel
    }, tShared("dialog.cancelBtn")), (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
      type: "submit",
      fs: "12px",
      bg: "--color-brand-red-main",
      thin_button: true,
      disabled: isLoading,
      loadingMessage: isLoading ? tShared("forms.sendingButton") : null
    }, tShared("forms.submitButton"))))));
  }));
}

var FormButtons = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1hnmu7c3"
} : 0)( true ? {
  name: "1gj4lye",
  styles: "display:flex;justify-content:space-evenly"
} : 0);

var Error = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1hnmu7c2"
} : 0)( true ? {
  name: "1y58js7",
  styles: "color:red;font-size:11px;width:100%;text-align:center;margin-left:25px;margin-top:10px"
} : 0);

var ContentLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hnmu7c1"
} : 0)( true ? {
  name: "7ilvyh",
  styles: "& .label-customs{font-size:13px;}"
} : 0);

var GridCardContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hnmu7c0"
} : 0)( true ? {
  name: "1sau53o",
  styles: "display:grid;grid-template-columns:repeat(3, calc(80% / 3));margin:0px auto;column-gap:10px;align-items:center;justify-content:center;@media (max-width: 768px){grid-template-columns:repeat(1, calc(80% / 1));row-gap:10px;}div{height:130px;display:flex;justify-content:space-evenly;flex-direction:column;align-items:center;border:1.5px solid #ccc;border-radius:5px;transition:all 0.3s ease-in-out;:hover{cursor:pointer;transform:scale(1.05);transition:all 0.3s ease-in-out;}&.active{background-color:red;color:#fff;font-weight:500;}p{text-align:center;padding:0px 10px;font-size:13px;}}"
} : 0);
// EXTERNAL MODULE: ./node_modules/@emotion/css/dist/emotion-css.esm.js + 1 modules
var emotion_css_esm = __webpack_require__(18872);
;// CONCATENATED MODULE: ./shared/components/dialogs/complete-signup.dialog/index.tsx


function complete_signup_dialog_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function CompleteSignUpDialog(props) {
  var open = props.open;
  var t = (0,next_intl_cjs_production_min.useTranslations)("CompleteSignUpDialog");
  var configProp = {
    open: open,
    fullWidth: true,
    maxWidth: "md"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(StyledDialog, configProp, (0,emotion_react_browser_esm/* jsx */.tZ)(DialogTitle/* default */.Z, {
    sx: {
      mt: 2
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    textAlign: "center",
    margin: "auto"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("h3", {
    css: styles.title
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(BoldTitle, null, t("header.title")))))), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogContent/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)("div", {
    className: messageContainer
  }, (0,emotion_react_browser_esm/* jsx */.tZ)("p", null, t("message.firstp"), (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), (0,emotion_react_browser_esm/* jsx */.tZ)("br", null), t("message.secondp"))), (0,emotion_react_browser_esm/* jsx */.tZ)(CompleteSignUpForm, null))));
}

var StyledDialog = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Dialog/* default */.Z,  true ? {
  target: "eh025671"
} : 0)( true ? {
  name: "2dq3js",
  styles: "& .MuiDialog-paper{background-color:var(#efeff1);border-radius:20px;}"
} : 0);

var BoldTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eh025670"
} : 0)( true ? {
  name: "15p8j2o",
  styles: "font-weight:700;text-transform:uppercase"
} : 0);

var messageContainer = /*#__PURE__*/(0,emotion_css_esm/* css */.iv)( true ? {
  name: "1ujb5vu",
  styles: "font-size:12px;max-width:500px;margin:0 auto;margin-bottom:20px;p{text-align:center;}"
} : 0);
var styles = {
  title: {
    marginBottom: 12
  }
};
// EXTERNAL MODULE: ./shared/components/forgot-password-form/index.tsx
var forgot_password_form = __webpack_require__(44959);
// EXTERNAL MODULE: ./shared/components/buttons/return-button/index.tsx
var return_button = __webpack_require__(83247);
;// CONCATENATED MODULE: ./shared/components/restore-password-dialog/index.tsx


function restore_password_dialog_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










function RestorePasswordDialog(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose;
  var tShared = (0,next_intl_cjs_production_min.useTranslations)("shared");
  var dispatch = (0,redux_hooks/* useAppDispatch */.T)();
  var configProp = {
    open: open,
    onClose: onClose,
    fullWidth: true,
    maxWidth: "sm"
  };
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(restore_password_dialog_StyledDialog, configProp, (0,emotion_react_browser_esm/* jsx */.tZ)(DialogTitle/* default */.Z, {
    style: {
      paddingBottom: "0"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    spacing: 1
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "space-between"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(return_button/* default */.Z, {
    "aria-label": "return to login",
    onClick: function onClick() {
      return dispatch((0,auth_dialog_slice/* openAuthDialog */.dn)("signin"));
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    variant: "text",
    colortext: "--color-brand-grey-secondary",
    onClick: onClose
  }, tShared("dialog.closeBtn"))))), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogContent/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(forgot_password_form/* default */.Z, {
    onClose: onClose
  }))));
}

var restore_password_dialog_StyledDialog = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Dialog/* default */.Z,  true ? {
  target: "e1mr3dyp0"
} : 0)( true ? {
  name: "2dq3js",
  styles: "& .MuiDialog-paper{background-color:var(#efeff1);border-radius:20px;}"
} : 0);
// EXTERNAL MODULE: ./shared/components/signin-form/index.tsx
var signin_form = __webpack_require__(76214);
;// CONCATENATED MODULE: ./shared/components/signin-dialog/index.tsx


function signin_dialog_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









function SignInDialog(props) {
  var open = props.open,
      onClose = props.onClose,
      openSignUp = props.openSignUp,
      openRestorePassword = props.openRestorePassword;
  var tShared = (0,next_intl_cjs_production_min.useTranslations)("shared");
  var dispatch = (0,redux_hooks/* useAppDispatch */.T)();

  var onLoginSuccess = function onLoginSuccess() {
    dispatch((0,auth_dialog_slice/* closeAuthDialog */.iw)());
  };

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(signin_dialog_StyledDialog, {
    open: open,
    onClose: onClose
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(DialogTitle/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    spacing: 1
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    textAlign: "right"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    variant: "text",
    colortext: "--color-brand-grey-secondary",
    onClick: onClose
  }, tShared("dialog.closeBtn"))))), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogContent/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(signin_form/* default */.Z, {
    openSignUp: openSignUp,
    openRestorePassword: openRestorePassword,
    onLoginSuccess: onLoginSuccess
  }))));
}

var signin_dialog_StyledDialog = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Dialog/* default */.Z,  true ? {
  target: "e1vlzjig0"
} : 0)( true ? {
  name: "2dq3js",
  styles: "& .MuiDialog-paper{background-color:var(#efeff1);border-radius:20px;}"
} : 0);
// EXTERNAL MODULE: ./shared/components/signup-form/index.tsx
var signup_form = __webpack_require__(30488);
;// CONCATENATED MODULE: ./shared/components/signup-dialog/index.tsx


function signup_dialog_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







function SignUpDialog(props) {
  var open = props.open,
      onClose = props.onClose,
      openSignIn = props.openSignIn;
  var tShared = (0,next_intl_cjs_production_min.useTranslations)("shared");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(signup_dialog_StyledDialog, {
    open: open,
    onClose: onClose
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(DialogTitle/* default */.Z, {
    style: {
      paddingBottom: "0"
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    container: true,
    spacing: 1
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
    item: true,
    xs: 12,
    textAlign: "right"
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
    variant: "text",
    colortext: "--color-brand-grey-secondary",
    onClick: onClose
  }, tShared("dialog.closeBtn"))))), (0,emotion_react_browser_esm/* jsx */.tZ)(DialogContent/* default */.Z, null, (0,emotion_react_browser_esm/* jsx */.tZ)(signup_form/* default */.Z, {
    onSignUpSuccess: onClose,
    openSignIn: openSignIn
  }))));
}

var signup_dialog_StyledDialog = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Dialog/* default */.Z,  true ? {
  target: "e1oh40iu0"
} : 0)( true ? {
  name: "2dq3js",
  styles: "& .MuiDialog-paper{background-color:var(#efeff1);border-radius:20px;}"
} : 0);
;// CONCATENATED MODULE: ./shared/components/auth-dialogs/index.tsx









function AuthDialogs() {
  var _useAppSelector = (0,redux_hooks/* useAppSelector */.C)(function (_ref) {
    var AuthDialog = _ref.AuthDialog,
        Auth = _ref.Auth;
    return [AuthDialog.dialog, Auth.user];
  }),
      _useAppSelector2 = (0,slicedToArray/* default */.Z)(_useAppSelector, 2),
      openDialog = _useAppSelector2[0],
      user = _useAppSelector2[1];

  var dispatch = (0,redux_hooks/* useAppDispatch */.T)();

  var handleClose = function handleClose() {
    return dispatch((0,auth_dialog_slice/* closeAuthDialog */.iw)());
  };

  (0,react.useEffect)(function () {
    if (user && !user.type) {
      dispatch((0,auth_dialog_slice/* openAuthDialog */.dn)("complete-signup"));
    }
  }, [user, dispatch]);
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(SignInDialog, {
    open: openDialog === "signin",
    onClose: handleClose,
    openSignUp: function openSignUp() {
      return dispatch((0,auth_dialog_slice/* openAuthDialog */.dn)("signup"));
    },
    openRestorePassword: function openRestorePassword() {
      return dispatch((0,auth_dialog_slice/* openAuthDialog */.dn)("restore-password"));
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(SignUpDialog, {
    open: openDialog === "signup",
    onClose: handleClose,
    openSignIn: function openSignIn() {
      return dispatch((0,auth_dialog_slice/* openAuthDialog */.dn)("signin"));
    }
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(RestorePasswordDialog, {
    open: openDialog === "restore-password",
    onClose: handleClose
  }), (0,emotion_react_browser_esm/* jsx */.tZ)(CompleteSignUpDialog, {
    open: openDialog === "complete-signup"
  }));
}
// EXTERNAL MODULE: ./shared/context/news.context.tsx
var news_context = __webpack_require__(30995);
;// CONCATENATED MODULE: ./shared/components/nav-bar/index.tsx


function nav_bar_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }











function NavBar() {
  var width = (0,use_width_hook/* useWidth */.z)();

  var _useShowNews = (0,news_context/* useShowNews */.H)(),
      showNews = _useShowNews.showNews;

  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(ContentNav, {
    showNews: showNews
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(MXAppBar, null, (0,emotion_react_browser_esm/* jsx */.tZ)(MXToolbar, null, ["sm", "xs", "md"].includes(width) ? (0,emotion_react_browser_esm/* jsx */.tZ)(components_MobileMenu, null) : (0,emotion_react_browser_esm/* jsx */.tZ)(components_DesktopMenu, null)), (0,emotion_react_browser_esm/* jsx */.tZ)(AuthDialogs, null))));
}

/* harmony default export */ var nav_bar = (NavBar);
var Spacing = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "enkga0e3"
} : 0)( true ? {
  name: "82a6rk",
  styles: "flex:1"
} : 0);

var ContentNav = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "enkga0e2"
} : 0)(function (_ref) {
  var showNews = _ref.showNews;
  return showNews && "margin-top: 124px;";
}, "@media screen and (max-width: 768px){margin-top:0px;}" + ( true ? "" : 0));

var MXAppBar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(AppBar/* default */.Z,  true ? {
  target: "enkga0e1"
} : 0)( true ? {
  name: "9hwdp",
  styles: "width:100%;background-color:#fff;box-shadow:0px 2px 2px rgba(0, 0, 0, 0.05)"
} : 0);

var MXToolbar = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Toolbar/* default */.Z,  true ? {
  target: "enkga0e0"
} : 0)( true ? {
  name: "wxl1hz",
  styles: "display:flex;flex-direction:row;height:73px;width:100%;margin:0 auto;@media screen and (min-width:600px){padding-left:54px;padding-right:0px;}"
} : 0);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/index.mjs
var dist = __webpack_require__(79661);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./shared/models/functions/query-string-helper.ts
var query_string_helper = __webpack_require__(23622);
;// CONCATENATED MODULE: ./custom-hooks/usePersistParams.hook.js







function usePersistParams() {
  var _useSessionStorage = (0,dist/* useSessionStorage */.Xs)("code", {
    id: null,
    type: null
  }),
      _useSessionStorage2 = (0,slicedToArray/* default */.Z)(_useSessionStorage, 2),
      code = _useSessionStorage2[0],
      setCode = _useSessionStorage2[1];

  var router = (0,next_router.useRouter)();

  var handleStringify = function handleStringify(type) {
    if (type === "referer") {
      return (0,query_string_helper/* queryFormatter */.Bt)({
        referer: code.id
      });
    }

    return (0,query_string_helper/* queryFormatter */.Bt)({
      areferer: code.id
    });
  };

  (0,react.useEffect)(function () {
    var _queryParserUrl = (0,query_string_helper/* queryParserUrl */.HL)(window.location.href),
        query = _queryParserUrl.query;

    var data = {
      id: query.referer || query.areferer,
      type: "areferer"
    };

    if (Boolean(query.referer)) {
      data.type = "referer";
    }

    if (!(0,lodash.isEqual)(data, code) && Boolean(data.id) && Boolean(data.type)) {
      setCode(data);
    }

    if (!Boolean(data.id) && Boolean(code.id)) {
      var queryStrings = (0,lodash.isEmpty)(query) ? handleStringify(code.type) : (0,query_string_helper/* queryFormatter */.Bt)(query) + "&" + handleStringify(code.type);
      var pathName = window.location.pathname + "?";
      var url = pathName + queryStrings;
      router.replace(url, undefined, {
        shallow: true
      });
    }
  }, [router.asPath, code.id, code.type, router.query]);
  return null;
}

/* harmony default export */ var usePersistParams_hook = (usePersistParams);
;// CONCATENATED MODULE: ./shared/components/layout/index.tsx





function Layout(_ref) {
  var children = _ref.children,
      showFooter = _ref.showFooter,
      backgroundColorFooter = _ref.backgroundColorFooter;
  usePersistParams_hook();
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, (0,emotion_react_browser_esm/* jsx */.tZ)(nav_bar, null), (0,emotion_react_browser_esm/* jsx */.tZ)("main", null, children), (0,emotion_react_browser_esm/* jsx */.tZ)("section", {
    style: {
      backgroundColor: backgroundColorFooter
    }
  }, (0,emotion_react_browser_esm/* jsx */.tZ)(footer, null)));
}

/***/ }),

/***/ 29036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ RequestErrorModal; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _components_message_modal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36481);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18872);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







/**
 * General purpose error modal for requests.
 * Pass either an `error` to parse from axios (AxiosError)
 * or a `message` string to display.
 */
function RequestErrorModal(_ref) {
  var open = _ref.open,
      title = _ref.title,
      error = _ref.error,
      message = _ref.message,
      buttonMsg = _ref.buttonMsg,
      close = _ref.close;
  var errorBody = message ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ErrorSubtitle, null, message) : error ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ParseReqError, error) : null;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_message_modal__WEBPACK_IMPORTED_MODULE_1__/* .ModalMessage */ .P, {
    open: open,
    variant: "error",
    title: title !== null && title !== void 0 ? title : "Error",
    body: errorBody,
    handleClose: close,
    buttonText: buttonMsg !== null && buttonMsg !== void 0 ? buttonMsg : "OK"
  });
}

function ParseReqError(_ref2) {
  var response = _ref2.response,
      request = _ref2.request;
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_5__.useTranslations)("error.http");
  var errorsBody = null;
  var errorMsg = t("default"); // The request was made and the server responded with a status code
  // that falls out of the range of 2xx
  // console.log(response, 'a')

  if (response) {
    var status = response.status,
        _response$data = response.data,
        message = _response$data.message,
        errors = _response$data.errors;
    console.log(response, "a");

    if (message) {
      errorMsg = message;
    } else if (status > 499) {
      errorMsg = t("500");
    } else if (status === 401) {
      errorMsg = t("401");
    } else if (status === 403) {
      errorMsg = t("403");
    } else if (status === 404) {
      errorMsg = t("404");
    } else if ([409, 406].includes(status)) {
      errorMsg = t("406");
    }

    if (status === 422) {
      if (typeof errors === "object") {
        var parsedErrors = Object.values(errors).map(function (errors) {
          return errors;
        }).flat();
        console.log(parsedErrors);
        errorsBody = parsedErrors.length > 1 ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("ul", {
          className: errorList,
          role: "list"
        }, parsedErrors.map(function (error, i) {
          return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("li", {
            key: i
          }, error);
        })) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)("p", {
          className: singleError
        }, parsedErrors.at(0));
      }
    }
  } else if (request) {
    // The request was made but no response was received
    // `request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    console.log(request);
  }

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ErrorSubtitle, null, errorMsg), errorsBody);
}

var ErrorSubtitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("strong",  true ? {
  target: "er2dai30"
} : 0)( true ? {
  name: "1lzd6zb",
  styles: "font-size:14px;margin-bottom:10px;color:var(--color-brand-grey-quaternary)"
} : 0);

var errorList = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)( true ? {
  name: "crumug",
  styles: "list-style:inside;text-align:left;margin:0 20px;margin-top:10px"
} : 0);
var singleError = /*#__PURE__*/(0,_emotion_css__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)( true ? {
  name: "1r0yqr6",
  styles: "margin-top:10px"
} : 0);

/***/ }),

/***/ 69194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OAuthButtons; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(13179);
// EXTERNAL MODULE: ./api/base-services.request.ts + 1 modules
var base_services_request = __webpack_require__(11882);
;// CONCATENATED MODULE: ./api/auth.request.ts

function getLoginRedirectURL(social) {
  return base_services_request/* baseURL */.v2 + "/v2/clients/login/" + social;
}
// EXTERNAL MODULE: ./node_modules/next-intl/dist/next-intl.cjs.production.min.js
var next_intl_cjs_production_min = __webpack_require__(42746);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./shared/components/oAuthButtons/index.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var OAuthEntities = [{
  name: "Facebook",
  link: getLoginRedirectURL("facebook"),
  icon: "/icons/icon_facebook_logo.png",
  show: "production" === "stage"
}, {
  name: "Google",
  link: getLoginRedirectURL("google"),
  icon: "/icons/icon-google-logo.png",
  show: true
}];
function OAuthButtons() {
  var t = (0,next_intl_cjs_production_min.useTranslations)("signUpForm");
  return (0,emotion_react_browser_esm/* jsx */.tZ)(react.Fragment, null, OAuthEntities.filter(function (x) {
    return x.show;
  }).map(function (_ref, i) {
    var name = _ref.name,
        link = _ref.link,
        icon = _ref.icon;
    return (0,emotion_react_browser_esm/* jsx */.tZ)(SignInWith, {
      key: i,
      href: link
    }, (0,emotion_react_browser_esm/* jsx */.tZ)((image_default()), {
      src: icon,
      alt: name + ' icon',
      width: 26,
      height: 26
    }), (0,emotion_react_browser_esm/* jsx */.tZ)("span", {
      css: styles.oauth_btn_lbl
    }, t("oAuthButton", {
      social: name
    })));
  }));
}

var SignInWith = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1c2bd340"
} : 0)( true ? {
  name: "1pw0dcm",
  styles: "width:100%;border:1px solid #D4D4D4;display:flex;justify-content:center;max-width:363px;height:44px;align-items:center;border-radius:22px;margin:auto;&:hover{background-color:#f6f6f696;}&+&{margin-top:14px;}"
} : 0);

var styles = {
  oauth_btn_lbl: {
    fontWeight: 'bold',
    marginLeft: '10px'
  }
};

/***/ }),

/***/ 76214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SignInForm; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59499);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74231);
/* harmony import */ var _components_text_field_password_field__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54489);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(67720);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82580);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(48228);
/* harmony import */ var api_clients_clients_request__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(62804);
/* harmony import */ var shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1283);
/* harmony import */ var store_feature_auth_auth_slice__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42550);
/* harmony import */ var custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99109);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(66621);
/* harmony import */ var _oAuthButtons__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69194);
/* harmony import */ var _text_field__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22900);
/* harmony import */ var _message_modal__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36481);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(70917);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


















var initialValues = {
  email: "",
  password: ""
};
function SignInForm(props) {
  var openSignUp = props.openSignUp,
      onLoginSuccess = props.onLoginSuccess,
      openRestorePassword = props.openRestorePassword;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(),
      Modal = _useState[0],
      SetModal = _useState[1];

  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_15__.useTranslations)("signinForm");
  var alertT = (0,next_intl__WEBPACK_IMPORTED_MODULE_15__.useTranslations)("alerts");

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var dispatch = (0,custom_hooks_redux_hooks__WEBPACK_IMPORTED_MODULE_10__/* .useAppDispatch */ .T)();
  var goToSignUp;
  var gotToRestorePassword;
  var validationSchema = yup__WEBPACK_IMPORTED_MODULE_2__/* .object */ .Ry({
    email: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required(""),
    password: yup__WEBPACK_IMPORTED_MODULE_2__/* .string */ .Z_().required("")
  });
  var resendConfirmEmailM = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_16__/* .useMutation */ .D)(api_clients_clients_request__WEBPACK_IMPORTED_MODULE_7__/* .userResendConfirmEmail */ .lf, {
    onSuccess: function onSuccess(res) {
      SetModal({
        open: true,
        title: alertT("resendEmailSuccess.title"),
        body: alertT("resendEmailSuccess.body"),
        buttonText: alertT("resendEmailSuccess.button"),
        handleClose: function handleClose() {
          return SetModal(_objectSpread(_objectSpread({}, Modal), {}, {
            open: false
          }));
        }
      });
    },
    onError: function onError(_ref) {
      var response = _ref.response;
    }
  });

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_16__/* .useMutation */ .D)(api_clients_clients_request__WEBPACK_IMPORTED_MODULE_7__/* .userSignIn */ .ii),
      isLoading = _useMutation.isLoading,
      isSuccess = _useMutation.isSuccess,
      mutateAsync = _useMutation.mutateAsync;

  function onSubmit(values) {
    mutateAsync(values).then(function (res) {
      var user = res.user,
          token = res.token;
      dispatch((0,store_feature_auth_auth_slice__WEBPACK_IMPORTED_MODULE_9__/* .setUser */ .av)(user));
      dispatch((0,store_feature_auth_auth_slice__WEBPACK_IMPORTED_MODULE_9__/* .setToken */ .o4)(token));
      onLoginSuccess();
    })["catch"](function (err) {
      var response = err.response;

      if ((response === null || response === void 0 ? void 0 : response.status) === 422) {
        var _response$data, _response$data$errors;

        if ((_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$errors = _response$data.errors) !== null && _response$data$errors !== void 0 && _response$data$errors.email) {
          SetModal({
            variant: "error",
            open: true,
            title: alertT("resendEmail.title"),
            body: alertT("resendEmail.body"),
            buttonText: alertT("resendEmail.button"),
            handleClose: function handleClose(e) {
              SetModal(_objectSpread(_objectSpread({}, Modal), {}, {
                open: false
              }));

              if (e == "forceClose") {
                return;
              }

              resendConfirmEmailM.mutate({
                email: values.email
              });
            }
          });
          return;
        }

        setErrorMessage(t("error.message"));
      } else {
        setErrorMessage(t("error.genericMessage"));
      }
    });
  }

  if (openSignUp) {
    goToSignUp = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(SignUpButton, {
      onClick: openSignUp,
      className: "redirect"
    }, t("user-signup"));
  } else {
    goToSignUp = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
      href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_8__/* .CPagesPath.es.signup */ .K.es.signup
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(SignUpButton, {
      className: "redirect"
    }, t("user-signup")));
  }

  if (openRestorePassword) {
    gotToRestorePassword = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(RestorePasswordButton, {
      onClick: openRestorePassword
    }, t("restore-password"));
  } else {
    gotToRestorePassword = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
      href: shared_models_const_pages_path__WEBPACK_IMPORTED_MODULE_8__/* .CPagesPath.es.forgotPassword */ .K.es.forgotPassword
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(RestorePasswordButton, null, t("restore-password")));
  }

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Formik */ .J9, {
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true
  }, function (formik) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(formik__WEBPACK_IMPORTED_MODULE_5__/* .Form */ .l0, {
      className: "signin-form-hubspot-remaxrd"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      container: true,
      mb: 3
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 9,
      textAlign: "center",
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)("h3", null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(BoldTitle, null, t("header.title")), "\xA0"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      container: true,
      spacing: 2
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 9,
      mx: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_oAuthButtons__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, null)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      container: true,
      sx: {
        mt: 4,
        mb: 1
      },
      alignItems: "center",
      justifyContent: "center"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      item: true,
      xs: 5
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
      variant: "middle"
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      item: true,
      xs: 2,
      sx: {
        textAlign: "center"
      }
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(OpcionalMsg, null, "o bien")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      item: true,
      xs: 5
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
      variant: "middle"
    }))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 8,
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_text_field__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
      name: "email",
      label: t("field.email")
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 8,
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_components_text_field_password_field__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      name: "password",
      label: t("field.password") + "*"
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      textAlign: "center",
      my: 1
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_Button__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      type: "submit",
      fs: "12px",
      bg: "--color-brand-red-main",
      thin_button: true,
      disabled: !formik.isValid || isLoading || isSuccess,
      loadingMessage: isLoading ? t("sending") : null
    }, t("submitButton"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      textAlign: "center"
    }, goToSignUp, "\xA0|\xA0", gotToRestorePassword)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_message_modal__WEBPACK_IMPORTED_MODULE_14__/* .ModalMessage */ .P, {
      title: "Aviso",
      body: errorMessage,
      variant: "error",
      open: !!errorMessage,
      handleClose: function handleClose() {
        return setErrorMessage("");
      }
    }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_message_modal__WEBPACK_IMPORTED_MODULE_14__/* .ModalMessage */ .P, Modal));
  });
}

var BoldTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "efha5sr4"
} : 0)( true ? {
  name: "15p8j2o",
  styles: "font-weight:700;text-transform:uppercase"
} : 0);

var OpcionalMsg = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "efha5sr3"
} : 0)( true ? {
  name: "1576zdn",
  styles: "font-size:12px;color:var(--color-brand-grey-quaternary);text-transform:uppercase;font-weight:500"
} : 0);

var ThinTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "efha5sr2"
} : 0)( true ? {
  name: "148c1u2",
  styles: "font-weight:300;text-transform:uppercase"
} : 0);

var SignUpButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a",  true ? {
  target: "efha5sr1"
} : 0)( true ? {
  name: "qogufz",
  styles: "font-size:14px;font-weight:500;line-height:13px;color:var(--color-brand-grey-secondary);cursor:pointer;&.redirect{color:var(--color-brand-blue-main);font-weight:700;}"
} : 0);

var RestorePasswordButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a",  true ? {
  target: "efha5sr0"
} : 0)( true ? {
  name: "1ted63q",
  styles: "font-size:14px;font-weight:500;line-height:13px;color:var(--color-brand-grey-secondary);cursor:pointer"
} : 0);

/***/ }),

/***/ 30488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SignUpForm; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(67720);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82580);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _mask_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95114);
/* harmony import */ var _text_field__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22900);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66621);
/* harmony import */ var api_clients_clients_request__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62804);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(48228);
/* harmony import */ var _oAuthButtons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69194);
/* harmony import */ var _message_modal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36481);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74231);
/* harmony import */ var _components_modals_error_modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29036);
/* harmony import */ var _components_text_field_password_field__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54489);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var custom_hooks_data_layer_event_hook__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(65198);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



















var initialValues = {
  full_name: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  "g-recaptcha-response": ""
};
function SignUpForm(props) {
  var onSignUpSuccess = props.onSignUpSuccess,
      openSignIn = props.openSignIn,
      _props$isPage = props.isPage,
      isPage = _props$isPage === void 0 ? false : _props$isPage;
  var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_13__.useTranslations)("signUpForm");
  var tErrors = (0,next_intl__WEBPACK_IMPORTED_MODULE_13__.useTranslations)("error");
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_12__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      openSuccessModal = _useState[0],
      onOpenSuccessModal = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      responseErrors = _useState2[0],
      setResponseErrors = _useState2[1];

  var _useDataLayerEvent = (0,custom_hooks_data_layer_event_hook__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(),
      event = _useDataLayerEvent.event;

  var validationSchema = (0,yup__WEBPACK_IMPORTED_MODULE_9__/* .object */ .Ry)({
    full_name: (0,yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_)().required(tErrors("required")),
    phone: (0,yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_)(),
    email: (0,yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_)().email(tErrors("email")).required(tErrors("required")),
    password: (0,yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_)().min(8, tErrors("field-min", {
      min: 8
    })).required(tErrors("required")),
    confirmPassword: (0,yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_)().oneOf([(0,yup__WEBPACK_IMPORTED_MODULE_9__/* .ref */ .iH)("password"), null], tErrors("passwordMustMatch")).required(tErrors("required")) // "g-recaptcha-response": string().required(tErrors("captcha")),

  });

  var redirectToSignIn = function redirectToSignIn() {
    if (isPage) {
      router.push("/acceder");
      return;
    }

    if (openSignIn) openSignIn();
  };

  var _useMutation = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_15__/* .useMutation */ .D)(api_clients_clients_request__WEBPACK_IMPORTED_MODULE_6__/* .userSignUp */ .EQ, {
    onSuccess: function onSuccess(_data, variables) {
      event({
        event_name: "signup",
        body: {
          variant: "form",
          email: (variables === null || variables === void 0 ? void 0 : variables.email) || null,
          name: (variables === null || variables === void 0 ? void 0 : variables.full_name) || null,
          phone: (variables === null || variables === void 0 ? void 0 : variables.phone) || null
        }
      });
      onOpenSuccessModal(true);
    },
    onError: setResponseErrors
  }),
      mutateAsync = _useMutation.mutateAsync,
      isLoading = _useMutation.isLoading;

  function handleErrorModalClose() {
    setResponseErrors(null);
  }

  function handleSuccessModal() {
    onOpenSuccessModal(false);
    if (onSignUpSuccess) onSignUpSuccess();
  }

  var onSubmit = function onSubmit(values) {
    return mutateAsync(values);
  };

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Formik */ .J9, {
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    enableReinitialize: true
  }, function (formikProps) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(formik__WEBPACK_IMPORTED_MODULE_1__/* .Form */ .l0, {
      className: "register-form-hubspot-remaxrd"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      container: true,
      mb: 5
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 9,
      textAlign: "center",
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)("h3", {
      css: styles.title
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(BoldTitle, null, t("header.title")), "\xA0"), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)("p", {
      css: styles.subtitle
    }, t("header.message")))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      container: true,
      spacing: 2
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 9,
      mx: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_oAuthButtons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, null)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      container: true,
      sx: {
        mt: 4,
        mb: 1
      },
      alignItems: "center",
      justifyContent: "center"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 5
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
      variant: "middle"
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 2,
      sx: {
        textAlign: "center"
      }
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(OpcionalMsg, null, "o bien")), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 5
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
      variant: "middle"
    }))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 8,
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_text_field__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      name: "full_name",
      label: t("field.full_name") + "*",
      inputComponent: _mask_components__WEBPACK_IMPORTED_MODULE_3__/* .TextMaskInput */ .MX
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 8,
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_text_field__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      name: "email",
      label: t("field.email") + "*"
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 8,
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_text_field__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      name: "phone",
      label: t("field.phone"),
      inputComponent: _mask_components__WEBPACK_IMPORTED_MODULE_3__/* .PhoneMask */ .Qv
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 8,
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_components_text_field_password_field__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      name: "password",
      label: t("field.password") + "*"
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      sm: 8,
      margin: "auto"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_components_text_field_password_field__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      name: "confirmPassword",
      label: t("field.confirmPassword") + "*"
    })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      mb: 5,
      textAlign: "center"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      type: "submit",
      fs: "12px",
      bg: "--color-brand-red-main",
      thin_button: true,
      disabled: isLoading,
      loadingMessage: isLoading ? t("sending") : null
    }, t("submitButton"))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
      item: true,
      xs: 12,
      textAlign: "center"
    }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(SignInButton, null, "\xBFYa tienes una cuenta?"), "\xA0|\xA0", (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(SignInButton, {
      className: "redirect",
      onClick: redirectToSignIn
    }, "Iniciar sesi\xF3n"))));
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_message_modal__WEBPACK_IMPORTED_MODULE_8__/* .ModalMessage */ .P, {
    title: t("successfulSignUp.title"),
    body: t("successfulSignUp.content-text"),
    buttonText: "Ok",
    open: openSuccessModal,
    handleClose: handleSuccessModal,
    variant: "success"
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_16__/* .jsx */ .tZ)(_components_modals_error_modal__WEBPACK_IMPORTED_MODULE_10__/* .RequestErrorModal */ .V, {
    open: !!responseErrors,
    error: responseErrors,
    close: handleErrorModalClose
  }));
}

var BoldTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1d2td3n3"
} : 0)( true ? {
  name: "15p8j2o",
  styles: "font-weight:700;text-transform:uppercase"
} : 0);

var ThinTitle = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1d2td3n2"
} : 0)( true ? {
  name: "148c1u2",
  styles: "font-weight:300;text-transform:uppercase"
} : 0);

var OpcionalMsg = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span",  true ? {
  target: "e1d2td3n1"
} : 0)( true ? {
  name: "1576zdn",
  styles: "font-size:12px;color:var(--color-brand-grey-quaternary);text-transform:uppercase;font-weight:500"
} : 0);

var SignInButton = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("a",  true ? {
  target: "e1d2td3n0"
} : 0)( true ? {
  name: "qogufz",
  styles: "font-size:14px;font-weight:500;line-height:13px;color:var(--color-brand-grey-secondary);cursor:pointer;&.redirect{color:var(--color-brand-blue-main);font-weight:700;}"
} : 0);

var styles = {
  title: {
    marginBottom: 21
  },
  subtitle:  true ? {
    name: "o3j13o",
    styles: "font-size:11px;font-weight:500;line-height:13px;color:var(--color-brand-grey-quaternary)"
  } : 0,
  oauth_btn_lbl: {
    fontWeight: "bold",
    marginLeft: "10px"
  }
};

/***/ }),

/***/ 93524:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ TogglePasswordIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_icons_material_Visibility__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22961);
/* harmony import */ var _mui_icons_material_VisibilityOff__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72450);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93946);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87109);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }






var TogglePasswordIcon = function TogglePasswordIcon(props) {
  var handleToggle = props.handleToggle,
      showPassword = props.showPassword;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(InputAdornmentCustom, {
    position: "end"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    className: "button",
    "aria-label": "toggle password visibility",
    onClick: handleToggle,
    tabIndex: -1
  }, showPassword ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_Visibility__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_mui_icons_material_VisibilityOff__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, null)));
};

var InputAdornmentCustom = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,  true ? {
  target: "e1d6b4r80"
} : 0)( true ? {
  name: "anun7w",
  styles: "position:absolute;right:10px"
} : 0);

/***/ }),

/***/ 54489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PasswordField; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36864);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22900);
/* harmony import */ var _password_field_toggle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93524);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70917);





function PasswordField(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      showPassword = _useState[0],
      setShowPassword = _useState[1];

  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(___WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props, {
    type: showPassword ? "text" : "password",
    endAdornment: (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_password_field_toggle__WEBPACK_IMPORTED_MODULE_2__/* .TogglePasswordIcon */ .S, {
      showPassword: showPassword,
      handleToggle: function handleToggle() {
        return setShowPassword(!showPassword);
      }
    })
  }));
}

/***/ }),

/***/ 30995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useShowNews; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17674);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70917);



var MyContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
  showNews: false,
  onToggle: function onToggle() {},
  isCloseForUser: false,
  setCloseForUser: function setCloseForUser() {}
});

function NewsContext(props) {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      _React$useState2 = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_React$useState, 2),
      showNews = _React$useState2[0],
      setShownNews = _React$useState2[1];

  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_0__.useState(false),
      _React$useState4 = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_React$useState3, 2),
      isCloseForUser = _React$useState4[0],
      setCloseForUser = _React$useState4[1];

  var onToggle = function onToggle(manualShow) {
    if (manualShow == undefined) return setShownNews(!showNews);
    setShownNews(manualShow);
  };

  var values = {
    showNews: showNews,
    onToggle: onToggle,
    isCloseForUser: isCloseForUser,
    setCloseForUser: setCloseForUser
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(MyContext.Provider, {
    value: values
  }, props.children);
}

/* harmony default export */ __webpack_exports__["Z"] = (NewsContext);
function useShowNews() {
  var context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(MyContext);
  return context;
}

/***/ }),

/***/ 23622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bt": function() { return /* binding */ queryFormatter; },
/* harmony export */   "HL": function() { return /* binding */ queryParserUrl; }
/* harmony export */ });
/* unused harmony export queryParser */
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17563);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var defaultQueryFormatterOptions = {
  skipEmptyString: true,
  skipNull: true,
  arrayFormat: "bracket"
};
var defaultQueryParserOptions = {
  arrayFormat: "bracket"
};
function queryFormatter(data, options) {
  return query_string__WEBPACK_IMPORTED_MODULE_1__.stringify(data, _objectSpread(_objectSpread({}, defaultQueryFormatterOptions), options));
}
function queryParser(data, options) {
  return querystring.parse(data, _objectSpread(_objectSpread({}, defaultQueryParserOptions), options));
}
function queryParserUrl(data, options) {
  return query_string__WEBPACK_IMPORTED_MODULE_1__.parseUrl(data, _objectSpread(_objectSpread({}, defaultQueryParserOptions), options));
}

/***/ }),

/***/ 54540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "dn": function() { return /* binding */ openAuthDialog; },
/* harmony export */   "iw": function() { return /* binding */ closeAuthDialog; }
/* harmony export */ });
/* unused harmony export authDialogSlice */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66741);

var initialState = {
  dialog: null
};
var authDialogSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_0__/* .createSlice */ .oM)({
  name: "auth-dialog",
  initialState: initialState,
  reducers: {
    open: function open(state, _ref) {
      var payload = _ref.payload;
      state.dialog = payload;
    },
    close: function close(state) {
      state.dialog = null;
    }
  }
});
var _authDialogSlice$acti = authDialogSlice.actions,
    openAuthDialog = _authDialogSlice$acti.open,
    closeAuthDialog = _authDialogSlice$acti.close;

/* harmony default export */ __webpack_exports__["ZP"] = (authDialogSlice.reducer);

/***/ }),

/***/ 42550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ setUser; },
/* harmony export */   "kS": function() { return /* binding */ logout; },
/* harmony export */   "o4": function() { return /* binding */ setToken; }
/* harmony export */ });
/* unused harmony exports authSlice, clearAuth */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66741);
/* harmony import */ var api_clients_clients_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62804);
/* harmony import */ var shared_services_auth_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84100);



var initialState = {
  token: (0,shared_services_auth_service__WEBPACK_IMPORTED_MODULE_1__/* .getUserToken */ .N)(),
  user: (0,shared_services_auth_service__WEBPACK_IMPORTED_MODULE_1__/* .userState */ .K)()
};
var authSlice = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSlice */ .oM)({
  name: "auth",
  initialState: initialState,
  reducers: {
    setUser: function setUser(state, _ref) {
      var payload = _ref.payload;
      localStorage.setItem("user", JSON.stringify(payload));
      state.user = payload;
    },
    setToken: function setToken(state, _ref2) {
      var payload = _ref2.payload;
      localStorage.setItem("token", payload);
      state.token = payload;
    },
    clearAuth: function clearAuth(state) {
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      state.user = null;
      state.token = null;
    }
  }
});
var _authSlice$actions = authSlice.actions,
    setUser = _authSlice$actions.setUser,
    setToken = _authSlice$actions.setToken,
    clearAuth = _authSlice$actions.clearAuth;

var logout = function logout() {
  return function (dispatch) {
    (0,api_clients_clients_request__WEBPACK_IMPORTED_MODULE_0__/* .userLogout */ .Kv)().then(function () {
      dispatch(clearAuth());
    });
  };
};
/* harmony default export */ __webpack_exports__["ZP"] = (authSlice.reducer);

/***/ })

}]);